const styles = (theme) => ({
    modalConfirmTextBold: {
      fontWeight: 700,
    },
    cardGrid: {
      //paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
  },
  });
  
  export default styles;
  